<!-- <template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/index">
        <img v-if="roleInfo.PlatformLogoPath" :src="roleInfo.PlatformLogoPath" class="sidebar-logo" />
        <h1 v-else class="sidebar-title" style="font-size: 14px">{{ roleInfo.PlatformName || title }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/index">
        <img v-if="roleInfo.PlatformLogoPath" :src="roleInfo.PlatformLogoPath" class="sidebar-logo" />
        <img v-else="roleInfo.PlatformLogoPath" src="../../../assets/logo.png" class="sidebar-logo" />
        <h1 class="sidebar-title">{{ roleInfo.PlatformName || title }}</h1>
      </router-link>
    </transition>
  </div>
</template> -->
<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/home">
        <!-- 折叠时只显示 Logo 图片 -->
        <img src="../../../assets/logo.png" class="sidebar-logo" />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/home">
        <!-- 展开时显示 Logo 图片 + 标题 -->
        <img src="../../../assets/logo.png" class="sidebar-logo" />
        <h1 class="sidebar-title">{{ title }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["roleInfo"])
  },
  data() {
    return {
      title: "统建统服系统"
      //logo: "1"
      // logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 110px;
  line-height: 110px;
  background: #fff;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & .sidebar-logo {
      //width: 56px;
      height: 56px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #001952;
      font-weight: 600;
      line-height: 40px;
      font-size: 20px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
